import styled, { css } from 'styled-components';
import { spacer24 } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "Group",
  componentId: "sc-1v9hiho-0"
})(["padding-bottom:", ";", ";"], spacer24, function (props) {
  return props.inline && css(["display:flex;flex-wrap:wrap;"]);
});